if (!customElements.get("countdown-timer")) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const year = parseInt(this.dataset.year);
      const month = parseInt(this.dataset.month);
      const day = parseInt(this.dataset.day);
      const hour = parseInt(this.dataset.hour) || 0;
      const minute = parseInt(this.dataset.minute) || 0;

      this.hideTimer = this.dataset.hideTimer === "true";
      this.completeMessage = this.dataset.completeMessage || "";

      this.countDownDate = new Date(year, month - 1, day, hour, minute, 0, 0).getTime();

      this.timeDisplay = this.querySelector("[data-time-display]");
      this.messageDisplay = this.querySelector("[data-message-placeholder]");
      this.daysElement = this.querySelector("[data-days]");
      this.hoursElement = this.querySelector("[data-hours]");
      this.minutesElement = this.querySelector("[data-mins]");
      this.secondsElement = this.querySelector("[data-secs]");
    }

    connectedCallback() {
      this.updateTime();
    }

    disconnectedCallback() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
    }

    updateTime() {
      const now = new Date().getTime();
      const distance = this.countDownDate - now;

      this.renderCountdown(distance);

      if (distance >= 0) {
        this.animationFrameId = requestAnimationFrame(this.updateTime.bind(this));
      }
    }

    renderCountdown(distance) {
      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (this.daysElement) this.daysElement.textContent = CountdownTimer.addZero(days);
        if (this.hoursElement) this.hoursElement.textContent = CountdownTimer.addZero(hours);
        if (this.minutesElement) this.minutesElement.textContent = CountdownTimer.addZero(minutes);
        if (this.secondsElement) this.secondsElement.textContent = CountdownTimer.addZero(seconds);

        if (this.timeDisplay) {
          this.timeDisplay.classList.add("td-flash-sale--visible-flex");
          this.timeDisplay.classList.remove("td-flash-sale--hidden");
        }
        if (this.messageDisplay) {
          this.messageDisplay.classList.add("td-flash-sale--hidden");
          this.messageDisplay.classList.remove("td-flash-sale--visible-block");
        }
      } else {
        // Reset values to zero when countdown expires
        if (this.daysElement) this.daysElement.textContent = "00";
        if (this.hoursElement) this.hoursElement.textContent = "00";
        if (this.minutesElement) this.minutesElement.textContent = "00";
        if (this.secondsElement) this.secondsElement.textContent = "00";

        if (this.hideTimer && this.timeDisplay) {
          this.timeDisplay.classList.add("td-flash-sale--hidden");
          this.timeDisplay.classList.remove("td-flash-sale--visible-flex");
        }

        if (this.completeMessage && this.messageDisplay) {
          this.messageDisplay.classList.add("td-flash-sale--visible-block");
          this.messageDisplay.classList.remove("td-flash-sale--hidden");
        }
      }
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? "0" + x : x;
    }
  }

  customElements.define("countdown-timer", CountdownTimer);
}
